import App from 'app/app.js';
import 'app/service/StorageService.js';

function LtExpandableBannerCtrl($scope, $document, StorageService) {
  this.isOpen = true;
  this.cardOffersPresent = false;

  this.toggleBanner = function () {
    this.isOpen = !this.isOpen;
    StorageService.set('ui.expBanner', this.isOpen);
  };

  this.getOpenState = function () {
    var value = StorageService.get('ui.expBanner');
    this.isOpen = value === null ? true : value;
  };

  // stick to footer
  var scrollHandler = function () {
    if (window.innerHeight + $($document).scrollTop() > $('#footer').offset().top) {
      $('#expandable-banner').addClass('stuck').removeClass('un-stuck');
    } else {
      $('#expandable-banner').addClass('un-stuck').removeClass('stuck');
    }
  };

  var unwatch = $scope.$watch(
    'ltShow',
    function (value) {
      if (value) {
        this.getOpenState();
        $($document).on('scroll', scrollHandler);
      } else {
        $($document).off('scroll', scrollHandler);
      }
    }.bind(this)
  );

  $scope.$on('$destroy', function () {
    unwatch();
  });

  this.setCardOffersPresent = function (cardOffersPresent) {
    this.cardOffersPresent = cardOffersPresent;
  };
}

App.controller('LtExpandableBannerCtrl', ['$scope', '$document', 'StorageService', LtExpandableBannerCtrl]);
